import { faPills, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import { memo, useContext } from 'react';

import AppContext from '@/contexts/appContext';
import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import Card from '@/ui/components/Card';
import snakeCaseToTitleCase from '@/utils/snakeToTitleCase';

// const logdataExample = {
//   backfill: false,
//   created_at_datetime: '2023-06-22T22:00:00.000+00:00',
//   drug_category: 'alcohol',
//   kind: 'breath',
//   occurred_at_datetime: '2023-06-22T22:00:00.000+00:00',
//   program_name: 'Alcohol Program - Standard'
//   result: 'missed',
// };

const DrugScreenEvent = ({ activityLog }: TimelineSubcomponentProps): JSX.Element => {
  const { host } = useContext(AppContext);
  const { action, actor, data, object_id, timestamp } = activityLog;

  return (
    <div>
      <Card>
        <TimelineHeader
          icon={faPills}
          iconClassName="text-orange-700"
          subtitle={data?.result}
          title={
            <>
              {snakeCaseToTitleCase(action ?? '')}{' '}
              <a
                aria-label="Go to drug screen in Homebase"
                className="ml-1"
                href={`${host}/drug_screens/${object_id}`}
                target={'_blank'}
                rel="noreferrer">
                <FontAwesomeIcon className="ml-1" icon={faExternalLink} />
              </a>
            </>
          }
        />

        {data?.drug_category && <div>{data?.drug_category}</div>}
        {data?.kind && <div>{data.kind}</div>}
      </Card>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default memo(DrugScreenEvent);
